// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appwrapper[data-v-617ab0be]  {
  font-size: 1em;
}
.appwrapper[data-v-617ab0be]  .v-window {
  overflow: initial;
}
.v-alert[data-v-617ab0be] {
  width: 100%;
  z-index: 1000;
  position: fixed;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
